class UserLoginAbortedException extends Error {
    public name = "UserLoginAbortedException";
    constructor(message: string) {
        super(message);
    }
}

export default UserLoginAbortedException;
